import React, { useEffect } from "react";
import "./Css/AboutUS.css";
const TermOfUse = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: "59", behavior: "smooth" });
    }, 100);
  }, []);
  return (
    <div className="about-us">
      <h1>Terms of Use</h1>

      <p>
        When you visit DomainPlayNPlayGames.com and/or use any of its games,
        software, or related services, you fully agree to comply with these{" "}
        <strong>Terms of Use</strong> and our <strong>Privacy Policy</strong>.
        If you do not agree with these terms, you are not permitted to access
        the website or use any of its services. DomainPlayNPlayGames.com
        reserves the right to modify or update these terms at any time. You are
        encouraged to review this page regularly for updates.
      </p>

      <h2>Age Restriction</h2>
      <p>
        This website is intended for users under the age of 13 (children).
        Younger users are advised to access the website, use its services, or
        play its games under the supervision of their parents or guardians.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        Most games published on DomainPlayNPlayGames.com are suggested or
        submitted by independent developers, creators, or rights holders.
        DomainPlayNPlayGames.com cannot guarantee that all submitters have
        respected third-party intellectual property rights.
      </p>

      <p>
        If there is any claim of copyright or intellectual property
        infringement, DomainPlayNPlayGames.com will promptly remove the affected
        content upon receiving proper notification from the rightful owner or
        authorized organization.
      </p>

      <h2>External Links Disclaimer</h2>
      <p>
        This website may contain links to external websites that are not
        provided, maintained, or affiliated with DomainPlayNPlayGames.com. We do
        not control or assume responsibility for the content, privacy policies,
        or practices of any third-party websites.
      </p>

      <p>
        DomainPlayNPlayGames.com does not guarantee the accuracy, relevance,
        timeliness, or completeness of information found on external websites.
      </p>

      <h2>Advertisements</h2>
      <p>
        DomainPlayNPlayGames.com is not responsible or liable for any
        advertisements displayed on the website. Any dealings or interactions
        with advertisers are solely between you and the advertiser.
      </p>

      <h2>Changes to Terms</h2>
      <p>
        We reserve the right, at our sole discretion, to modify or replace these
        Terms of Use at any time. If changes are significant, we will make
        reasonable efforts to notify users prior to the updated terms taking
        effect.
      </p>

      <p>
        By continuing to access the website, play our games, or use our services
        after the revisions become effective, you agree to be bound by the
        updated terms. If you do not agree with the revised terms, please
        discontinue use of the website and its services.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions regarding these Terms of Use, please contact
        us.
      </p>
    </div>
  );
};
export default TermOfUse;
